/**
 * How far along the mapping is, in one line and a bar: fields in use out of fields that can be mapped,
 * and how many matches are waiting for the advisor's confirmation.
 */
import { Progress } from '@design-system';
import { fieldMapCopy } from '../lib/field-map-copy';
import type { FieldMapSummary as Summary } from '../lib/field-map-groups';

interface FieldMapSummaryProps {
  summary: Summary;
  pendingCount: number;
}

export function FieldMapSummary({ summary, pendingCount }: FieldMapSummaryProps) {
  return (
    <div className="mb-4">
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 text-sm">
        <span className="font-medium text-gray-900">{fieldMapCopy.summary(summary.ready, summary.total)}</span>
        {pendingCount > 0 && <span className="text-gray-600">{fieldMapCopy.summaryPending(pendingCount)}</span>}
      </div>
      <Progress
        value={summary.percent}
        aria-label={fieldMapCopy.summary(summary.ready, summary.total)}
        className="mt-2 h-2"
      />
    </div>
  );
}
